import React, { useState, useEffect } from "react";
import Pagination from "../common/Pagination";
import NavBar from "../common/NavBar";
import Footer from "../common/Footer";
import OwnerMenu from "../owner/OwnerMenu";
import FacilityModal from "../owner/OwnerModals/CreateFacilityModal"; // updated modal
import { useTranslation } from "react-i18next";

const Facilities = () => {
  const { t } = useTranslation();
  const [facilities, setFacilities] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 5;

  const getApiBaseUrl = () =>
    process.env.REACT_APP_API_URL || "http://localhost:8000";

  useEffect(() => {
    fetch(`${getApiBaseUrl()}/api/facilities/facilities/`)
      .then((response) => response.json())
      .then((data) => setFacilities(data))
      .catch((error) => console.error("Error fetching facilities:", error));
  }, []);

  const handleDelete = async (facilityId) => {
    if (!window.confirm(t("are_you_sure_delete_facility"))) return;
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/api/facilities/facilities/${facilityId}/`,
        { method: "DELETE" }
      );
      if (response.ok) {
        setFacilities((prev) => prev.filter((fac) => fac.id !== facilityId));
        alert(t("facility_deleted_successfully"));
      } else {
        alert(t("error_deleting_facility"));
      }
    } catch (error) {
      console.error("Error deleting facility:", error);
      alert(t("error_occurred_try_again"));
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <OwnerMenu />
      <div className="flex flex-col items-center mt-16">
        <h1 className="text-3xl font-bold mb-8">{t("Facilities")}</h1>

        <button
          onClick={() => {
            setSelectedFacility(null);
            setIsModalOpen(true);
          }}
          className="bg-blue-500 text-white px-4 py-2 rounded-md mb-4 hover:bg-blue-700"
        >
          {t("Add Facility")}
        </button>

        <div className="w-full max-w-4xl overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-100 text-center">
                <th className="py-3 px-4 border-b">{t("Name")}</th>
                <th className="py-3 px-4 border-b">{t("Type")}</th>
                <th className="py-3 px-4 border-b">{t("Customer Weighting")}</th>
                <th className="py-3 px-4 border-b">{t("Logo")}</th>
                <th className="py-3 px-4 border-b">{t("Attribution")}</th>
                <th className="py-3 px-4 border-b">{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {facilities.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE).map((facility) => (
                <tr key={facility.id} className="hover:bg-gray-50 text-center">
                  <td className="py-3 px-4 border-b">{facility.name}</td>
                  <td className="py-3 px-4 border-b">{facility.type}</td>
                  <td className="py-3 px-4 border-b">{facility.customer_weighting}</td>
                  <td className="py-3 px-4 border-b">
                    {facility.logo ? (
                      <img
                        src={facility.logo}
                        alt={facility.name}
                        className="w-10 h-10 object-contain mx-auto"
                      />
                    ) : (
                      <span className="text-gray-400">No Logo</span>
                    )}
                  </td>
                  <td className="py-3 px-4 border-b">{facility.attribution}</td>
                  <td className="py-3 px-4 border-b flex justify-center space-x-2">
                    <button
                      onClick={() => {
                        setSelectedFacility(facility);
                        setIsModalOpen(true);
                      }}
                      className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-700"
                    >
                      {t("Update")}
                    </button>
                    <button
                      onClick={() => handleDelete(facility.id)}
                      className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
                    >
                      {t("Delete")}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination totalItems={facilities.length} pageSize={PAGE_SIZE} currentPage={currentPage} onPageChange={setCurrentPage} />
      </div>

      {/* Modal */}
      {isModalOpen && (
        <FacilityModal
          isOpen={isModalOpen}
          facility={selectedFacility}
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => window.location.reload()}
        />
      )}

      <Footer />
    </div>
  );
};


export default Facilities;